import { ForecastItem, Forecast as ForecastType } from "libs/types";
import styled from "styled-components";

const Container = styled.div`
  overflow: auto;
`;

const Table = styled.table`
  margin-top: 6px;
  width: 100%;
  min-width: 780px;

  th, td {
    border: 1px solid #a0a0a0;
    font-size: 11px;
    font-weight: 600;
    padding: 4px;
  }
  th {
    border-bottom-width: 2px;
  }
`;

const Value = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
  }
`;

const Th = styled.th<{isNight: boolean;}>`
  background-color: ${props => props.isNight ? "#323335" : "#ebecee"};

  ${Value} {
    &.good {
      span {
        color: ${props => props.isNight ? "#cacbce" : "#000000"};
      }
    }
    &.ok {
      span {
        background-color: #da996f;
      }
    }
    &.bad {
      span {
        background-color: #cf574e;
      }
    }
  }
`;

const Td = styled.td<{isNight: boolean;}>`
  background-color: ${props => props.isNight ? "#323335" : "transparent"};

  &:first-child {
    text-align: center;
  }

  ${Value} {
    &.good {
      justify-content: flex-end;

      span {
        justify-content: flex-end;
        color: ${props => props.isNight ? "#cacbce" : "#000000"};
      }
    }
    &.ok {
      span {
        background-color: #cfdbec;
      }
    }
    &.bad {
      span {
        background-color: #7196c8;
      }
    }
    &.ok-n {
      span {
        background-color: #da996f;
      }
    }
    &.bad-n {
      span {
        background-color: #cf574e;
      }
    }
  }
`;

const SELECT_VALUES = [
  {
    key: "temperature",
    name: "Temperature"
  },
  {
    key: "relative_humidity",
    name: "Humidity"
  },
  {
    key: "wind_speed",
    name: "Wind"
  },
  {
    key: "total_clouds",
    name: "Total Clouds"
  },
  {
    key: "high_clouds",
    name: "High Clouds"
  },
  {
    key: "medium_clouds",
    name: "Medi Clouds"
  },
  {
    key: "low_clouds",
    name: "Low Clouds"
  }
];

const Forecast = ({data}: {data: ForecastType}) => {
  return <Container>
    <Table>
      <thead>
        <tr>
          <Th isNight={false}>{data.start_date}</Th>
          {data.hour.map((item, i) => <Th key={`hour_${i}_${item.value}_${item.status}_${item.is_night}`} isNight={item.is_night}>
            <Value className={item.status}>
              <span>{item.value < 10 ? `0${item.value}` : item.value}</span>
            </Value>
          </Th>)}
        </tr>
      </thead>
      <tbody>
        {SELECT_VALUES.map((value) => <tr key={value.key}>
          <Td isNight={false}>{value.name}</Td>
          {(data as any)[value.key].map((item: ForecastItem, i: number) => <Td key={`${value.key}_${i}_${item.value}_${item.status}_${item.is_night}`} isNight={item.is_night}>
            <Value className={item.status}>
              <span>{item.value}</span>
            </Value>
          </Td>)}
        </tr>)}
      </tbody>
    </Table>
  </Container>
}

export default Forecast;